module.exports = __webpack_public_path__ + "static/media/left-arrow.9aab5d9f.svg";